import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { AboutIntro } from "@/components/about/AboutIntro";
import { AboutMissionVision } from "@/components/about/AboutMissionVision";
import { AboutBusiness } from "@/components/about/AboutBusiness";
import { AboutFounder } from "@/components/about/AboutFounder";

export default function AboutUs() {
  return (
    <>
      <Seo
        title="About Us"
        description="RKG NATURALS is an agricultural products importer, exporter and wholesaler based in Maharashtra, India."
        path="/about-us"
      />
      <div data-testid="about-us-page">
        <PageHero eyebrow="About Us" title="About RKG NATURALS" />
        <AboutIntro />
        <AboutMissionVision />
        <AboutBusiness />
        <AboutFounder />
      </div>
    </>
  );
}
